import i18n from '@/i18n';

export default [
  {
    path: '/businesses',
    name: 'businesses',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'business',
          actions: ['view-nav-link', 'list-all'],
        },
      ],
      title: i18n.global.t('businesses'),
    },
    component: () => import('../../views/businesses/Index'),
    children: [
      {
        path: 'new',
        name: 'businesses-new',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'business',
              actions: ['store'],
            },
          ],
          title: i18n.global.t('businesses'),
        },
        component: () => import('../../views/businesses/AddNew.vue'),
      },
      {
        path: ':id(\\d+)',
        name: 'business-details',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'business',
              actions: ['view'],
            },
          ],
          title: i18n.global.t('business_details'),
        },
        component: () => import('../../views/businesses/Edit.vue'),
      },
    ],
  },
];
